// Шапка: сам блок авторизации теперь рендерит mod_auth серверно (POC C3) — гость
// видит «Войти», авторизованный «Мои заказы» → /orders/. JS тут только на два случая:
//   • выход из ЛК — кнопка [data-logout] на странице заказов (делегированно);
//   • живое обновление после входа через попап (Popup-auth.js шлёт auth:success без
//     reload) — серверный блок ещё гостевой, превращаем его в «Мои заказы».

const AUTH_MID = 2; // mod_auth в таблице modules

export function initHeaderAuth() {
	// Выход из ЛК — кнопка [data-logout] (на странице «Мои заказы»).
	document.addEventListener("click", async (e) => {
		const out = e.target.closest("[data-logout]");
		if (!out) return;
		e.preventDefault();
		await post("logout");
		window.location.href = "/";
	});

	// Вход через попап без перезагрузки — обновляем серверный блок на «Мои заказы».
	const btn = document.querySelector(".header-user-nav__link");
	if (!btn) return;
	document.addEventListener("auth:success", () => {
		const span = btn.querySelector("span") || btn;
		span.textContent = "Мои заказы";
		btn.removeAttribute("data-popup-open"); // больше не открываем попап
		if (btn.dataset.authBound) return;      // не вешать переход повторно
		btn.dataset.authBound = "1";
		btn.addEventListener("click", () => { window.location.href = "/orders/"; });
	});
}

function post(action) {
	return fetch(`/ajax.php?mid=${AUTH_MID}`, {
		method: "POST",
		body: new URLSearchParams({ action }),
	})
		.then((r) => r.json())
		.catch(() => null);
}
